export default "__VITE_ASSET__96076eae__"